<template>
  <v-card>
    <v-toolbar card dense color="transparent">
      <v-text-field
        flat
        solo
        prepend-icon="search"
        placeholder="Búsqueda rápida"
        v-model="search"
        hide-details
        class="hidden-sm-and-down"
      ></v-text-field>
      <v-select
        :items="sucursales"
        item-text="nombreSucursal"
        item-value="sucursalId"
        label="Sucursal"
        placeholder="Sucursal"
        @input="getInventarioBySucursal"
        single-line
      ></v-select>
      <!-- <v-toolbar-title>
        <h4>INVENTARIO DEL PRODUCTO</h4>
      </v-toolbar-title>-->
      <v-spacer></v-spacer>
      <v-btn
        color="success"
        dark
        fab
        small
        icon
        @click="abrirDialogNuevoInventario"
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <template>
        <v-data-table
          :headers="headers"
          :items="listaInventarioProducto"
          hide-actions
          :search="search"
          :rows-per-page-items="[10, 25, 50, { text: 'All', value: -1 }]"
          class="elevation-0"
          :loading="loadingInventario"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.aliasSucursal }}</td>
            <td class="text-lg-center">{{ props.item.sku }}</td>
            <td class="text-lg-center">{{ props.item.descripcionTalla }}</td>
            <td class="text-lg-center">
              <v-icon :color="props.item.codigoHtml" medium>widgets</v-icon>
            </td>
            <td class="text-lg-center">
              <v-text-field
                label="Cantidad en renta"
                v-model="props.item.cantidadRenta"
                type="number"
                :rules="[
                  () =>
                    props.item.cantidadRenta >= 0 || 'No puede ser negativo!',
                ]"
                @change="updateInventarioProducto(props.item)"
              ></v-text-field>
            </td>
            <td class="text-lg-center">
              <v-text-field
                label="Cantidad en venta"
                v-model="props.item.cantidadVenta"
                type="number"
                :rules="[
                  () =>
                    props.item.cantidadVenta >= 0 || 'No puede ser negativo!',
                ]"
                @change="updateInventarioProducto(props.item)"
              ></v-text-field>
            </td>
            <td class="text-lg-center">N/D</td>
            <!-- <td class="text-xs-right">
              <v-btn
                flat
                icon
                color="grey"
                @click="getProductoInventario(props.item.sucursalId, props.item.productoId)"
              >
                <v-icon>edit</v-icon>
              </v-btn>
  
            </td> -->
          </template>
        </v-data-table>
      </template>
      <v-divider></v-divider>
    </v-card-text>
    <form-inventario-producto
      :inventarioProducto="inventarioProducto"
      :producto="producto"
      @onInventarioProductoAdded="onInventarioProductoAdded"
      @onInventarioProductoUpdated="onInventarioProductoUpdated"
      ref="dialogInventarioProducto"
    ></form-inventario-producto>
    <confirm ref="confirm"></confirm>
  </v-card>
</template>

<script>
//Components
import confirm from "@/components/dialogs/Confirm";
import formInventarioProducto from "./FormInventarioProducto";

//Sevices
import inventarioProductoService from "@/services/inventarioProductoService";
import sucursalService from "@/services/sucursalService";

export default {
  components: {
    confirm,
    formInventarioProducto,
  },
  props: {
    producto: {
      type: Object,
    },
  },
  watch: {
    producto: function (newProducto) {
      this.extraerInventarioProducto();
    },
  },
  data() {
    return {
      search: "",
      headers: [
        {
          text: "SUCURSAL",
          align: "center",
          sortable: true,
          value: "aliasSucursal",
        },
        { text: "SKU", align: "center", value: "sku" },
        { text: "TALLA", align: "center", value: "descripcionTalla" },
        { text: "COLOR", align: "center", value: "codigoHtml" },
        { text: "DISPONIBLE RENTA", align: "center", value: "cantidadRenta" },
        { text: "DISPONIBLE VENTA", align: "center", value: "cantidadVenta" },
        { text: "RENTADOS", align: "center", value: "cantidadRentada" },
      ],
      listaInventarioProducto: [],
      inventarioProducto: {
        sucursalId: 0,
        catalogoRowId: 0,
        cantidadRenta: 0,
        cantidadVenta: 0,
      },
      sucursales: [],
      loadingInventario: false,
    };
  },
  mounted() {
    this.extraerInventarioProducto();
    this.getSucursales();
  },
  methods: {
    extraerInventarioProducto() {
      let self = this;
      self.$store.state.loadingInfo.show = true;
      inventarioProductoService
        .getAllByProducto(self.producto.productoId)
        .then((result) => {
          self.listaInventarioProducto = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    getSucursales() {
      let self = this;
      self.$store.state.loadingInfo.show = true;

      sucursalService
        .getAllForDrop()
        .then((result) => {
          self.sucursales = result;
          self.sucursales.push({ sucursalId: 0, nombreSucursal: "TODAS" });
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    getInventarioBySucursal(sucursalId) {
      let self = this;
      self.$store.state.loadingInfo.show = true;
      if (sucursalId === 0) {
        self.extraerInventarioProducto();
      } else {
        inventarioProductoService
          .getAllByProductoAndSucursal(self.producto.productoId, sucursalId)
          .then((result) => {
            self.listaInventarioProducto = result;
          })
          .catch((e) => {
            console.log(e);
            self.operationFailed(e);
          })
          .finally(() => {
            self.$store.state.loadingInfo.show = false;
          });
      }
    },
    abrirDialogNuevoInventario() {
      this.$store.state.tituloForm = "AGREGAR INVENTARIO PRODUCTO";
      this.$store.state.iconoForm = "/images/general/agregar-40.png";
      this.$refs.dialogInventarioProducto.resetForm();
      this.$refs.dialogInventarioProducto.openDialog();
    },
    updateInventarioProducto(inventarioItem) {
      let self = this;
      if (
        inventarioItem.cantidadRenta >= 0 &&
        inventarioItem.cantidadVenta >= 0
      ) {
        inventarioProductoService
          .update(inventarioItem)
          .then((result) => {
            self.$store.state.snackbar.color = "success";
            self.$store.state.snackbar.text = "Inventario actualizado";
            self.$store.state.snackbar.visible = true;
          })
          .catch((e) => {
            self.operationFailed(e);
            console.log(e);
          });
      }
    },
    onInventarioProductoAdded(inventarioProducto) {
      this.listaInventarioProducto.push(inventarioProducto);
    },
    onInventarioProductoUpdated(inventarioProducto) {
      var i = this.listaInventarioProducto.findIndex(
        (obj) =>
          obj.catalogoRowId == inventarioProducto.catalogoRowId &&
          obj.sucursalId == inventarioProducto.sucursalId
      );
      this.listaInventarioProducto.splice(i, 1, inventarioProducto);
    },
  },
};
</script>
